// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWithdrawRouteImport } from './routes/_authenticated/withdraw'
import { Route as AuthenticatedTransactionsRouteImport } from './routes/_authenticated/transactions'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedPwaDiagnosticsRouteImport } from './routes/_authenticated/pwa-diagnostics'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedDepositRouteImport } from './routes/_authenticated/deposit'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBotsRouteImport } from './routes/_authenticated/bots'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminWithdrawalsRouteImport } from './routes/_authenticated/admin.withdrawals'
import { Route as AuthenticatedAdminVerifyRouteImport } from './routes/_authenticated/admin.verify'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminSupportRouteImport } from './routes/_authenticated/admin.support'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminPlansRouteImport } from './routes/_authenticated/admin.plans'
import { Route as AuthenticatedAdminInviteCodesRouteImport } from './routes/_authenticated/admin.invite-codes'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin.emails'
import { Route as AuthenticatedAdminDepositsRouteImport } from './routes/_authenticated/admin.deposits'
import { Route as AuthenticatedAdminBuildLogsRouteImport } from './routes/_authenticated/admin.build-logs'
import { Route as AuthenticatedAdminBuildDiagnosticsRouteImport } from './routes/_authenticated/admin.build-diagnostics'
import { Route as AuthenticatedAdminBotsRouteImport } from './routes/_authenticated/admin.bots'
import { Route as AuthenticatedAdminAnnouncementsRouteImport } from './routes/_authenticated/admin.announcements'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TrustRoute = TrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PlansRoute = PlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedWithdrawRoute = AuthenticatedWithdrawRouteImport.update({
            id: '/withdraw',path: '/withdraw',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTransactionsRoute = AuthenticatedTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPwaDiagnosticsRoute = AuthenticatedPwaDiagnosticsRouteImport.update({
            id: '/pwa-diagnostics',path: '/pwa-diagnostics',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDepositRoute = AuthenticatedDepositRouteImport.update({
            id: '/deposit',path: '/deposit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBotsRoute = AuthenticatedBotsRouteImport.update({
            id: '/bots',path: '/bots',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWithdrawalsRoute = AuthenticatedAdminWithdrawalsRouteImport.update({
            id: '/withdrawals',path: '/withdrawals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminVerifyRoute = AuthenticatedAdminVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportRoute = AuthenticatedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPlansRoute = AuthenticatedAdminPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInviteCodesRoute = AuthenticatedAdminInviteCodesRouteImport.update({
            id: '/invite-codes',path: '/invite-codes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDepositsRoute = AuthenticatedAdminDepositsRouteImport.update({
            id: '/deposits',path: '/deposits',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBuildLogsRoute = AuthenticatedAdminBuildLogsRouteImport.update({
            id: '/build-logs',path: '/build-logs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBuildDiagnosticsRoute = AuthenticatedAdminBuildDiagnosticsRouteImport.update({
            id: '/build-diagnostics',path: '/build-diagnostics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBotsRoute = AuthenticatedAdminBotsRouteImport.update({
            id: '/bots',path: '/bots',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnnouncementsRoute = AuthenticatedAdminAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnnouncementsRoute: AuthenticatedAdminAnnouncementsRoute,AuthenticatedAdminBotsRoute: AuthenticatedAdminBotsRoute,AuthenticatedAdminBuildDiagnosticsRoute: AuthenticatedAdminBuildDiagnosticsRoute,AuthenticatedAdminBuildLogsRoute: AuthenticatedAdminBuildLogsRoute,AuthenticatedAdminDepositsRoute: AuthenticatedAdminDepositsRoute,AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute,AuthenticatedAdminInviteCodesRoute: AuthenticatedAdminInviteCodesRoute,AuthenticatedAdminPlansRoute: AuthenticatedAdminPlansRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminSupportRoute: AuthenticatedAdminSupportRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminVerifyRoute: AuthenticatedAdminVerifyRoute,AuthenticatedAdminWithdrawalsRoute: AuthenticatedAdminWithdrawalsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBotsRoute: AuthenticatedBotsRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDepositRoute: AuthenticatedDepositRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedPwaDiagnosticsRoute: AuthenticatedPwaDiagnosticsRoute,AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedSupportRoute: AuthenticatedSupportRoute,AuthenticatedTransactionsRoute: AuthenticatedTransactionsRoute,AuthenticatedWithdrawRoute: AuthenticatedWithdrawRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ForgotPasswordRoute: ForgotPasswordRoute,HelpRoute: HelpRoute,PlansRoute: PlansRoute,ResetPasswordRoute: ResetPasswordRoute,TrustRoute: TrustRoute,UnsubscribeRoute: UnsubscribeRoute,VerifyEmailRoute: VerifyEmailRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)